import React, { useState, useContext } from 'react';
import { AuthContext } from '../utils/AuthContext';
import { generateAcademicYears } from '../utils/academicYearUtils';
import foot from '../Assets/footer-bg.svg';
import { FaFacebook, FaYoutube, FaInstagram } from 'react-icons/fa';
import tree from "../Assets/tree-1.svg";
import tree1 from "../Assets/tree-2.svg";
import logo from "../Assets/kalam_kids_best_kindergarten_logo.png"
import fox from "../Assets/fox-color.svg";
import { FaXTwitter } from 'react-icons/fa6';
import { createEnquiry } from '../api/Api';
import { MdCheckCircle } from 'react-icons/md';

const Footer = () => {
  const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "Preschool",
  "name": "Kalam Kids Kindergarten",
  "image": "https://yourdomain.com/logo.png",
  "url": "https://www.kalamkids.com",
  "telephone": "+91-9080619003",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "No. 82, Dharapadavedu, Vellore Road",
    "addressLocality": "Katpadi",
    "addressRegion": "Tamil Nadu",
    "postalCode": "632007",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 12.900585,
    "longitude": 79.131234
  },
  "openingHours": "Mo-Sa 09:00-18:00",
  "priceRange": "$$",
  "sameAs": [
    "https://www.facebook.com/KalamKidsKindergarten",
    "https://www.youtube.com/@kalamkidskindergarten",
    "https://www.instagram.com/kalamkidskindergarten",
    "https://x.com/KidsKalam"
  ]
};

    const { academicYear } = useContext(AuthContext);
    const [isModalOpen, setModalOpen] = useState(false);
    const [showThankYou, setShowThankYou] = useState(false); // State for thank you message
   const [formData, setFormData] = useState({
      studentName: "",
      gender: "",
      dob: "",
      fatherName: "",
      fatherMobile: "",
      fatherEmail: "",
      motherName: "",
      motherMobile: "",
      motherEmail: "",
      area: "",
      city: "",
      state: "",
      age: "",
      academicYear: academicYear || "",
      plotNo: "", // New field
      street: "", // New field
      landmark: "", // New field
    });
    const academicYears = generateAcademicYears();

    const [isSubmitting, setIsSubmitting] = useState(false); // New state for form submission

    // ... (rest of your code remains the same)
  
    const handleSubmit = async (e) => {
      e.preventDefault();
      console.log("Form Data Submitted:", formData);
      setIsSubmitting(true); // Set isSubmitting to true when form is submitted
  
      // Basic validation
      if (!formData.studentName || !formData.fatherName) {
        alert("Please fill in all required fields.");
        setIsSubmitting(false); // Reset isSubmitting if validation fails
        return;
      }
  
      try {
        const response = await createEnquiry(formData);
        console.log("Response from server:", response);
  
        setShowThankYou(true);
        setTimeout(() => {
          setShowThankYou(false);
        }, 3000);
        setModalOpen(false);
        setIsSubmitting(false); // Reset isSubmitting after successful submission
      } catch (error) {
        console.error("Error submitting form:", error);
        alert("Failed to submit the form. Please try again.");
        setIsSubmitting(false); // Reset isSubmitting if submission fails
      }
    };
    const handleInputChange = (e) => {
      const { name, value } = e.target;
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
  
      // Calculate age if dob is updated
      if (name === "dob" && value) {
        const dob = new Date(value);
        const currentDate = new Date();
        let calculatedAge = currentDate.getFullYear() - dob.getFullYear();
        const monthDiff = currentDate.getMonth() - dob.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && currentDate.getDate() < dob.getDate())) {
          calculatedAge--;
        }
        setFormData((prevData) => ({
          ...prevData,
          age: calculatedAge, // Set the calculated age
        }));
      }
    };
 
  return (
    <div className="mt-24 navbar-link over">
      <div className="relative ">
        <img 
          src={tree} 
          alt="Tree" 
          className="absolute z-30 top-0 left-12 h-16 sm:h-20 md:h-24 -mt-10 md:-mt-14"
        />
        <img 
          src={fox} 
          alt="Fox" 
          className="absolute z-30 top-0 left-32 sm:left-32 md:left-36 h-24 sm:h-28 md:h-36 -mt-16 sm:-mt-20 md:-mt-24"
        />
        <img  
          src={tree1} 
          alt="Tree" 
          className="absolute z-30 top-0 right-20 sm:right-28 md:right-32 h-16 sm:h-20 md:h-24 -mt-10 sm:-mt-14"
        />

      </div>

      <div className="bg-[#f4f1ea] w-full relative flex flex-col    items-center overflow-hidden h-auto md:h-[400px]">
        {/* Background image */}
        <img 
          src={foot} 
          alt="Footer Background" 
          className="absolute inset-0 -top-0 left-0 h-[960px] md:h-[620px] w-full object-cover"
        />

        {/* Content */}
        <div className="relative z-10 w-full max-w-7xl px-6 mt-8 md:mt-32 flex flex-col md:flex-row justify-between items-center space-y-8 md:space-y-0">
          <div className="flex flex-col text-[#16bab1]enter md:text-left">
            <a href="/" className="mb-2 text-[#2b3a42]">Home</a>
            <a href="/about" className="mb-2 text-[#2b3a42]">About</a>
            <a href="/program" className="mb-2 text-[#2b3a42]">Program</a>
          </div>
          <div className="flex flex-col text-[#16bab1]enter md:text-left">
          <a href="/contactUs" className="mb-2 text-[#2b3a42]">Contact Us</a>

            <a  onClick={() => setModalOpen(true)} className="mb-2 text-[#2b3a42]">Enquiry</a>
            {/* <a href="#location" className="mb-2 text-[#2b3a42]">Location</a> */}
          </div>
          <div className="mt-4 md:mt-2">
            <img src={logo} alt="logo" className="h-32 w-32 md:h-44  md:w-auto mx-auto md:mx-0" />
          </div>
          <div className="flex flex-col text-[#16bab1]enter md:text-left ">
          <span className="text-[#2b3a42]">No,#23 New Sankaranpalayam ,<br />
           Near Tollgate Vellore</span>

            {/* <span className="text-[#2b3a42]">Vellore,</span>
            <span className="text-[#2b3a42]">Sankaranpalayam</span> */}
            <a href="https://maps.app.goo.gl/hTB8SKKuTvGFenrD8" className="text-[#16bab1] ">Google map</a>
            <span className="mt-2 text-[#2b3a42]">Phone: (+91) 99945 58487</span>
            <a href="mailto:hi@kindergarten.com" className="text-[#16bab1] ">kidsofkalam@gmail.com</a>
          </div>
          <div className="flex flex-col items-center md:items-start">
          <button onClick={() => setModalOpen(true)} className="bg-[#16bab1]  sensei-text text-white h-12 px-6 rounded-md mb-4">
                Enquiry
              </button>
        

            <div className="relative z-10 flex space-x-3">
              <a href="https://www.facebook.com/KalamKidsKindergarten" className="text-[#2b3a42] text-[#16bab1]xl"><FaFacebook /></a>
              <a href="https://www.youtube.com/@kalamkidskindergarten" className="text-[#2b3a42] text-[#16bab1]xl"><FaYoutube /></a>
              <a href="https://www.instagram.com/kalamkidskindergarten" className="text-[#2b3a42] text-[#16bab1]xl"><FaInstagram /></a>
              <a href="https://x.com/KidsKalam" className="text-[#2b3a42] text-[#16bab1]xl"><FaXTwitter />
              </a>

            </div>
            
          </div>
        </div>

        {/* Footer bottom-left text */}
        <div className="relative w-full px-6 mt-8 text-[#16bab1]enter md:text-left">
          <p className="text-sm text-[#2b3a42]">
            &copy; {new Date().getFullYear()} Kalam Kids Kindergarten. All rights reserved. |   Designed and Maintained by Green Emerald
          </p>
        </div>
      </div>
      
      {isModalOpen && (
  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
     <div className="bg-white p-4 rounded-2xl shadow-2xl w-full max-w-4xl ">
    <div className="flex items-center  justify-center mb-5 border-b pb-4">
  <div className="flex items-center space-x-4">
    <img src={logo } alt="Kalam Kids Logo" className="h-40 w-40 object-contain" />
    <div className="bg-gray-600 h-10 w-0.5 "></div>

    <div>
      <h1 className="text-[#16bab1] text-[#16bab1]xl md:text-[#16bab1]xl font-extrabold">
        KINDERGARTEN ADMISSION ENQUIRY FORM : {academicYear}
      </h1>
      <p className="text-gray-700 font-medium text-sm md:text-base mt-1">
        Smart start. Strong foundation.
      </p>
    </div>
  </div>
</div>

      <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-3 gap-5">
        <input
          type="text"
          name="studentName"
          placeholder="Student Name"
          className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
          onChange={handleInputChange}
        />
        <select
          name="gender"
          className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
          onChange={handleInputChange}
        >
          <option value="">Select Gender</option>
          <option value="male">Male</option>
          <option value="female">Female</option>
          <option value="other">Other</option>
        </select>

        {/* Date of Birth */}
        <div className="relative">
          <input
            type="date"
            name="dob"
            className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
            onChange={handleInputChange}
          />
          {formData.age !== "" && (
            <div className="absolute top-4 right-12 flex items-center text-gray-700 font-medium">
              Age: <span className="ml-2">{formData.age}</span>
            </div>
          )}
        </div>

        {/* Father Details */}
        <input
          type="text"
          name="fatherName"
          placeholder="Father Name"
          className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
          onChange={handleInputChange}
        />
        <input
          type="text"
          name="fatherMobile"
          placeholder="Father's Mobile Number"
          className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
          onChange={handleInputChange}
        />
        <input
          type="email"
          name="fatherEmail"
          placeholder="Father's Email ID"
          className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
          onChange={handleInputChange}
        />

        {/* Mother Details */}
        <input
          type="text"
          name="motherName"
          placeholder="Mother Name"
          className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
          onChange={handleInputChange}
        />
        <input
          type="text"
          name="motherMobile"
          placeholder="Mother's Mobile Number"
          className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
          onChange={handleInputChange}
        />
        <input
          type="email"
          name="motherEmail"
          placeholder="Mother's Email ID"
          className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
          onChange={handleInputChange}
        />

        {/* New Address Fields */}
        <input
          type="text"
          name="plotNo"
          placeholder="Plot No/Name"
          className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
          onChange={handleInputChange}
        />
        <input
          type="text"
          name="street"
          placeholder="Street"
          className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
          onChange={handleInputChange}
        />
        <input
          type="text"
          name="landmark"
          placeholder="Landmark"
          className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
          onChange={handleInputChange}
        />

        {/* Address */}
        <input
          type="text"
          name="area"
          placeholder="Area"
          className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
          onChange={handleInputChange}
        />
        <input
          type="text"
          name="city"
          placeholder="City"
          className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
          onChange={handleInputChange}
        />
        <input
          type="text"
          name="state"
          placeholder="State"
          className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
          onChange={handleInputChange}
        />
        <select
          name="academicYear"
          className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
          value={formData.academicYear}
          onChange={handleInputChange}
          required
        >
          <option value="">Select Academic Year</option>
          {academicYears.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
      </form>

      {/* Action Buttons */}
      <div className="flex justify-end gap-4 mt-8">
        <button
          className="px-6 py-2 border text-black rounded-md"
          onClick={() => setModalOpen(false)}
        >
          Close
        </button>
        <button
          type="submit"
          className="px-6 py-2 bg-[#16bab1] text-white rounded-md shadow-lg"
          onClick={handleSubmit}
        >
        {isSubmitting ? <Loader /> : "Submit"}
        </button>
      </div>
    </div>
  </div>
)}

      {showThankYou && (
              <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                <div className="bg-white p-6 rounded-lg shadow-lg w-80">
                   <MdCheckCircle
                                      className="text-green-500 mx-auto mb-3"
                                      size={48}
                                    />
                  <h2 className="text-lg font-semibold text-[#16bab1] text-center">Thank You!</h2>
                  <p className="text-[#16bab1] text-center mt-2">Your enquiry has been submitted successfully.</p>
                  {/* <div className="flex justify-center mt-4">
                    {/* <button
                      className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                      onClick={() => setShowThankYou(false)}
                    >
                      Close
                    </button> */}
                  {/* </div> */}
                </div>
              </div>
)}
               <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(localBusinessSchema) }}
      />
    </div>
  );
};

export default Footer;
